import { ReactElement, useCallback } from "react";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import { Icon } from "../Icon/Icon";
import styles from "./ExpandButton.module.less";
import { ButtonClickEventArgs } from "../Button/Button";
import classNames from "classnames";

type ExpandButtonProps = {
	text: string | ReactElement;
	onClick?(arg: ButtonClickEventArgs): void;
	bubbleClick?: boolean;
	trackingId: string;
	isExpanded: boolean;
	size?: ExpandButtonSize;
	tooltip?: string;
};

export const ExpandButton = (props: ExpandButtonProps): ReactElement => {
	const {
		text,
		bubbleClick,
		onClick,
		size = "normal",
		tooltip,
		isExpanded,
		trackingId
	} = props;

	const clickHandler = useCallback(
		(args: React.MouseEvent) => {
			const {
				clientX,
				clientY
			} = args;

			if (bubbleClick === false) {
				args.preventDefault();
				args.stopPropagation();
			}

			if (onClick) {
				onClick({ clientX, clientY });
			}
		},
		[bubbleClick, onClick]
	);

	const title: string | undefined = tooltip
		|| (
			typeof text === "string"
				? text
				: undefined
		);

	return (
		<ButtonBase
			trackingId={trackingId}
			className={classNames(
				styles.root,
				{
					[styles.root_small]: size === "small"
				}
			)}
			onClick={clickHandler}
			title={title}
		>
			<span className={styles.text}>
				{text}
			</span>
			<span className={styles.icon}>
				<Icon value={isExpanded ? "chevron-up" : "chevron-down"}/>
			</span>
		</ButtonBase>
	);
};
ExpandButton.displayName="ExpandButton";

type ExpandButtonSize =
	| "normal"
	| "small";
